import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

import { setUser, signIn } from '../../actions/userActions';

const USER_REGISTRATION_CUSTOM_CLAIM = 'https://app.getobok.com/registration/';
const USER_INVITATION_CUSTOM_CLAIM = 'https://app.getobok.com/invitation/';

function AuthInfoManager() {
  const {
    isAuthenticated,
    getAccessTokenSilently,
    user,
  } = useAuth0();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeAuthInfo = useCallback(async () => {
    if (isAuthenticated) {
      const isRegistered = user[USER_REGISTRATION_CUSTOM_CLAIM];
      const isInvited = user[USER_INVITATION_CUSTOM_CLAIM];

      let navigateDirection = window.location.pathname;

      dispatch(signIn(getAccessTokenSilently));
      dispatch(setUser(user));

      const isActiveIntro = user.intro?.active;

      // user is not onboard yet
      if (!isRegistered && !isInvited) {
        navigateDirection = '/registration';
      }

      // user has an active intro
      if (isActiveIntro) {
        navigateDirection = '/dashboard/integrations/add';
      }

      // Ensure the beta dashboard redirection
      if (navigateDirection === '/dashboard') {
        window.location.href = `${process.env.REACT_APP_BETA_OBOK_URL}/dashboard?from=app`;
      }

      // eslint-disable-next-line max-len
      navigate(navigateDirection);
    }
  }, [isAuthenticated, getAccessTokenSilently, user, dispatch, navigate]);

  useEffect(() => {
    storeAuthInfo();
  }, [storeAuthInfo]);

  return null;
}

export default AuthInfoManager;
